import store from '@/store'

/**
 * @function setCorrelationId
 * @param {Object} response - the response from the original api call
 * @returns {Object} the same response object to pass through.
 * @description sets the correlation id from the response header
 * This is needed for site affinity. Once site affinity is not an issue this may no longer be needed.
 */
export const setCorrelationId = async (response) => {
  const oldCorrelationId = store.state.correlationId
  const newCorrelationId = response.headers['src-correlation-id']

  if (newCorrelationId && newCorrelationId !== oldCorrelationId) {
    await store.dispatch('setCorrelationId', newCorrelationId)
  }
  return response
}
